<template>
    <div class="ged">
        <el-row type="flex" justify="center">
            <el-col :span="22">
                <h1>An Adaptive Scale Sea Surface Temperature Predicting Method Based on Deep Learning With Attention
                    Mechanism
                </h1>

                <h3>ABSTRACT</h3>
                <p style="text-align: justify">
                    Sea surface temperature (SST) prediction plays an important role in ocean-related fields. It is
                    challenging due to the nonlinear temporal dynamics with changing complex factors and the inherent
                    difficulties in long-scale predictions. Conventional models often lack efficient information
                    extraction
                    and cannot meet the requirements of long-scale predictions. Therefore, the gate recurrent unit (GRU)
                    encoder–decoder with SST codes and dynamic influence link (DIL), GRU encoder– decoder (GED), which
                    considered both the static and dynamic influence, is proposed in this letter. Each SST code,
                    capturing
                    the static information more effectively, was computed by all hidden states of the encoder and was
                    individually associated with each predicted SST. The DIL, capturing the dynamic influence, connected
                    the
                    SST code with the early predicted future SST for solving the long-scale dependence problem. GED was
                    tested on the Bohai Sea SST data sets and South China Sea SST data sets and compared with
                    full-connected
                    long-short term memory (FC-LSTM) and support vector regression. The results demonstrated that GED
                    outperformed others on different prediction scales and different prediction terms (daily, weekly,
                    and
                    monthly), especially in terms of long-scale and long-term predictions. In addition, attention
                    relationships between historical and future SSTs were further explored, and there was a meaningful
                    finding that each future daily mean SST of Bohai Sea most strongly correlated with the past 27th to
                    29th
                    historical values.
                </p>

                <el-image
                        :src="urls[0]"
                        :preview-src-list="urls"
                        lazy>
                </el-image>

                <h3>DATASETS|CODES|README</h3>
                <el-link type="primary" :underline="false"
                         href="https://pan.baidu.com/s/1COPo85Ldk7iZIN3FAbSetA">
                    download (password:vefk)
                </el-link>
            </el-col>
        </el-row>
    </div>
</template>

<script>
    export default {
        name: 'ged',

        data() {
            return {
                urls: [require('../assets/ged/ged.jpg')],
            };
        }
    }
</script>

<style scoped>
    .ged {
        background: #f5f5f7;
        min-height: 100vh;
        padding-bottom: 64px;
    }

    .ged :deep(.el-col) {
        text-align: left;
        padding: 60px 0;
    }

    .ged :deep(h1) {
        font-size: 36px;
        letter-spacing: -0.5px;
        color: #1d1d1f;
        line-height: 1.2;
        margin-bottom: 32px;
        padding-bottom: 24px;
        border-bottom: 1px solid #d2d2d7;
    }

    .ged :deep(h3) {
        font-size: 13px;
        font-weight: 600;
        letter-spacing: 0.8px;
        text-transform: uppercase;
        color: #6e6e73;
        margin: 36px 0 12px;
    }

    .ged :deep(p) {
        font-size: 16px;
        line-height: 1.75;
        color: #3a3a3c;
    }

    .ged :deep(.el-image) {
        display: block;
        width: 40%;
        margin: 24px auto;
        border-radius: 16px;
        box-shadow: 0 4px 24px rgba(0, 0, 0, 0.1);
    }

    @media (max-width: 680px) {
        .ged :deep(.el-image) {
            width: 80%;
        }
    }

    .ged :deep(.el-link) {
        font-size: 15px;
        font-weight: 500;
    }
</style>